import { formatPhone } from "../../hooks/validation";
import { ColumnMeta } from "../CustomDatatable/CustomDatatable";
import { Company } from "../../store/types";

export const phoneTemplate = (rowData: any) => {
  return formatPhone(rowData?.phone);
};

export const companyColumns: ColumnMeta<Company>[] = [
  { field: "name", header: "Компания" },
  { field: "users", header: "Количество пользователей" },
  { field: "licenses", header: "Количество лицензий" },
  { field: "phone", header: "Телефон", body: phoneTemplate },
  { field: "email", header: "Почта" },
];
